import React, { useEffect, useState } from 'react';
import '../App.css';
import './HeroSection.css';

const POSTER = '/videos/urbanspatial-poster.jpg';

// Pick the lightest video that still looks right, and skip it entirely when the
// connection is metered or very slow -- the poster alone carries the page then.
function pickSource() {
  if (typeof window === 'undefined') return null;

  const conn =
    navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  if (conn) {
    if (conn.saveData) return null;
    if (/(^|-)2g$/.test(conn.effectiveType || '')) return null;
    if (conn.effectiveType === '3g') return '/videos/urbanspatial-480.mp4';
  }

  return window.innerWidth <= 768
    ? '/videos/urbanspatial-480.mp4'
    : '/videos/urbanspatial-720.mp4';
}

function HeroSection() {
  const [src, setSrc] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setSrc(pickSource());
  }, []);

  return (
    <div className='hero-container'>
      <div
        className='hero-poster'
        style={{ backgroundImage: `url(${POSTER})` }}
        aria-hidden='true'
      />
      {src && (
        <video
          className={`hero-video${ready ? ' is-ready' : ''}`}
          src={src}
          poster={POSTER}
          autoPlay
          loop
          muted
          playsInline
          preload='auto'
          onCanPlay={() => setReady(true)}
        />
      )}
    </div>
  );
}

export default HeroSection;
